import { axios } from '@/utils/request'

export default {
    getWechatSetting(){
        return axios.get('/api/services/app/Setting/GetWechatSetting')
    },
    updateWechatSetting(input){
        return axios.put('/api/services/app/Setting/UpdateWechatSetting',input)
    }
}